
import { Island } from '@rta/rta-blueprint-library';

import { ComponentController } from '@r-core';
import { IslandSymbol, type SvgActionMenuConfig, TrashSymbol } from '@r-components';

type Metadata = {
	controller: ComponentController;
	islandId: string;
};

export const islandMenuConfig = (island: Island, metadata: Metadata): SvgActionMenuConfig => {
	return {
		key: island.id,
		icon: (props: React.SVGProps<SVGCircleElement>) => <IslandSymbol {...props}/>,
		menuOptions: {
			menuButtonRadius: 3
		},
		items: [
			{
				icon: (props) => <TrashSymbol {...props}/>,
				label: 'D',
				tooltip: 'Delete Island',
				confirm: true,
				hidden: () => metadata.controller.readonly || island.isDefaultIsland,
				handler: () => {
					island.refMap.islands.delete(island.id);
				}
			},
			{
				label: 'RF',
				tooltip: 'Rotate Clockwise',
				confirm: true,
				hidden: () => metadata.controller.readonly,
				handler: () => {
					island.rotateClockwise();
				}
			},
			{
				label: 'RB',
				tooltip: 'Rotate Counter Clockwise',
				confirm: true,
				hidden: () => metadata.controller.readonly,
				handler: () => {
					island.rotateCounterClockwise();
				}
			}
		]
	};
};
